/**
 * ThemeToggle — sun/moon switcher, mounted in Profile + KioskShell footer.
 */

import { Moon, Sun } from 'lucide-react';
import { useTheme } from '@/hooks/useTheme';
import { cn } from '@/lib/cn';

export function ThemeToggle({ className }: { className?: string }) {
  const { theme, toggle } = useTheme();
  const isDark = theme === 'dark';

  return (
    <button
      type="button"
      aria-label={isDark ? 'Switch to light theme' : 'Switch to dark theme'}
      onClick={toggle}
      className={cn(
        'inline-flex items-center justify-center rounded-full border border-white/10 bg-white/[0.04] p-2 transition-colors hover:bg-white/[0.08] focus-ring',
        className,
      )}
    >
      {isDark ? (
        <Sun className="h-4 w-4 text-brand-cyan-300" />
      ) : (
        <Moon className="h-4 w-4 text-brand-azure-700" />
      )}
    </button>
  );
}
